import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import labormate from "../../Assets/Projects/labormate.png";
import magni from "../../Assets/Projects/magni.png";
import shopi from "../../Assets/Projects/shopi.png";
import stream from "../../Assets/Projects/stream.png";
import codeq from "../../Assets/Projects/codeq.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={labormate}
              isBlog={false}
              title="LaborMate"
              description="The purpose of this project is to help labors to find a job and similarly to help consumers to find labor that can meet their requirements, comparing their skills, experience and visiting charges."
              ghLink="https://github.com/rohan-singh987/laborMate"
              demoLink="https://labormate-f64aa.web.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={magni}
              isBlog={false}
              title="MagnifiQue"
              description="A public platform where you can explore a wide range of ideas, display photography skills, share those cherishable moments "
              ghLink="https://github.com/rohan-singh987/magnifiQue"
              demoLink="https://magnifique-rns.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={stream}
              isBlog={false}
              title="StreamQue"
              description="Stream anything whatever you want wherever you want"
              ghLink="https://github.com/rohan-singh987/streamQue"
              demoLink="https://github.com/rohan-singh987/streamQue"
              />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={codeq}
              isBlog={false}
              title="CodeQue"
              description="Codequee is a powerful online platform that enables collaborative programming and learning through an online room with a code editor."
              ghLink="https://github.com/rohan-singh987/codeQuee"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
              />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={shopi}
              isBlog={false}
              title="ShopiQue"
              description="An Ecommerce Website where you can find, compare and buy items"
              ghLink="https://github.com/rohan-singh987/shopiQue"
              demoLink="https://shopique.vercel.app/"              
            />
          </Col>
         

         


        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
